import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/svg/logoparty.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0f13717e")

_pushScopeId("data-v-0f13717e")
const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "You're Invited to", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_grid, { class: "party-invitation-page" }, {
        default: _withId(() => [
          (_ctx.party)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                style: {"height":"80%"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, { class: "center-center" }, {
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _hoisted_1,
                        _hoisted_2,
                        _createVNode("h1", null, _toDisplayString(_ctx.party.party_name), 1),
                        _hoisted_3,
                        _createVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.party.date_time)), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.party.location_address), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})